import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import Icon from '../../components/icons';
import { URLS } from '../../_config';
import General from './_components/general';
import LogActivity from './_components/logActivity';
import { useNavigate, useParams } from 'react-router-dom';
import Drawer from '../../components/Drawer';
import Button from '../../components/elements/button';
import { Dropdown, Menu } from '../../components/Dropdown';
import CreateWorkOrder from '../WorkOrder/_components/createWorkOrder';
import { useChecklistApi } from '../../store/api/hooks/checklistApiHook';
import { useDialog } from '../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
const FacilityDetails: React.FC = () => {
    const [tab, setTab] = useState('general');
    const params: any = useParams();
    const facilityApi = useFacilitiesApi();
    const addNewfacilityRef: any = React.createRef<HTMLButtonElement>();
    const [facility, setfacility] = useState<any>(null);
    const [purchaseCost, setPurchaseCost] = useState<number>(0);

    const [facilitydetails, setfacilityDatails] = useState<any>(null)
    const createDrwerWORef: any = useRef();
    const createFacilityRef: any = useRef();
    const [editData, setEditData] = useState<any>(null);
    const [copyData, setCopyData] = useState<any>(null);
    const [qrImg, setQrImg] = useState<any>(null);
    const createWORef: any = useRef();
    const checklistAPI: any = useChecklistApi();
    const { confirm } = useDialog();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const getfacilitylist = (facilityID: any) => {
        const payload = {
            facilityID: facilityID
        }
        facilityApi.getFacilityDetails(payload, (data: any) => {
            setfacility(data ? data : []);
        }, (error: any) => { });
    };
    const toggleDiv = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (params.id) {
            getfacilitylist(params.id);
        }
    }, [params]);

    return (
        <Layout>
            <Header title={facility?.facilityName} back={URLS.FACILITIES}>
                <Header.Right>
                    {/* <Drawer _ref={addNewfacilityRef} onClose={() => { }} outsideClose={false}>
                        <Drawer.Button>
                            <Button theme='light'>Edit</Button>
                        </Drawer.Button>
                        <Drawer.Content title={facility ? copyData ? 'Create New facilitys' : 'Edit facilitys' : 'Create New facilitys'} className='!w-[39.563rem]'>
                            <Createfacilitys editData={copyData ? copyData : facility} onCreate={() => {
                                setEditData(null);
                                setCopyData(null)
                                addNewfacilityRef.current.close();
                            }} onCancel={() => {
                                setEditData(null);
                                setCopyData(null)
                                addNewfacilityRef.current.close();
                            }} />
                        </Drawer.Content>
                    </Drawer> */}


                    {/* <Drawer _ref={createDrwerWORef} onClose={() => {
                        console.log('close drawer', createFacilityRef?.current?.reset);
                        getfacilitysList(params.id);
                        setEditData(null);
                        setCopyData(null)
                        createDrwerWORef?.current?.close();
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button>Create New Task</Button>
                        </Drawer.Button>
                        <Drawer.Content title={`Create New Task`} className='!w-[39.563rem]'>
                            <CreateWorkOrder _ref={createWORef} editData={null} prefillData={facilitydetails?.prefillData_wo || null} onCreate={() => {
                                setEditData(null);
                                setfacility(null);
                                setCopyData(null)
                                getfacilitysList(params.id);
                                createDrwerWORef?.current?.close();

                            }} onCancel={() => {
                                setEditData(null);
                                setfacility(null);
                                getfacilitysList(params.id);
                                setCopyData(null)
                                createDrwerWORef?.current?.close();

                            }} />
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary' className='h-[2.25rem]'><Icon name='threedote' size={1.25} className='' /></Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>

                            <Menu onClick={() => { handleActionChange('delete', facility) }}>Delete</Menu>
                            <Menu onClick={() => { handleActionChange('duplicate', facility) }}>Duplicate</Menu>

                        </Dropdown.Content>
                    </Dropdown> */}


                </Header.Right>
            </Header>
            <div className='flex justify-between items-center px-5 border-b border-gray-200'>
                <div className='px-5  h-[3.75rem] flex items-center gap-[2.188rem] text-gray-600 text-[0.938rem] font-medium'>
                    <button className={`hover:text-black relative flex h-full items-center ${tab == 'general' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('general')}>
                        General
                    </button>
                    <button className={`hover:text-black relative flex h-full items-center ${tab == 'logactivity' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('logactivity')}>
                        Log Activity
                    </button>
                </div>
            </div>
            {isOpen &&
                <div
                    className={`mt-6 absolute w-[16.6rem] right-6 top-[6rem] z-20 p-6 bg-white rounded-xl shadow-lg transition-all duration-500 ease-in-out overflow-hidden ${isOpen ? 'max-h-[300px]' : 'max-h-0'
                        }`}
                    style={{
                        maxHeight: isOpen ? '300px' : '0', // For smooth transition
                    }}
                >
                    <img src={qrImg} className='w-[13.5rem] h-[13.5rem]' />

                </div>
            }

            <div className={`px-5 overflow-y-auto`} style={{ maxHeight: `calc(100vh - 125px)` }}>
                {tab === 'general' && <General />}
                {tab === 'logactivity' && <LogActivity facilityID={params.id} />}
            </div>
        </Layout>
    );
};

export default FacilityDetails;